var _TestEnvFeatureComponent;
import Component from '@glimmer/component';
import { isProduction } from 'core/utils/runtime-environment';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class TestEnvFeatureComponent extends Component {
  get isTestEnv() {
    return !isProduction();
  }
}
_TestEnvFeatureComponent = TestEnvFeatureComponent;
setComponentTemplate(precompileTemplate("\n    {{#if this.isTestEnv}}\n      {{yield}}\n    {{/if}}\n  ", {
  strictMode: true
}), _TestEnvFeatureComponent);